import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Markdown + ReactJS = MDX.`}</p>
    <h1>{`RIP Jekyll and `}<a parentName="h1" {...{
        "href": "https://daizeng1984.bitbucket.io/"
      }}>{`My Old Home Page`}</a></h1>
    <p>{`It's been an idea for a while since the `}<a parentName="p" {...{
        "href": "/2019-05-12-reactjs-webpack-jekyll"
      }}>{`posts`}</a>{` last year. After I upgraded my mac, Jeykyll is broken in my new setup. Installing ruby's native package is nightmare, and I cannot bear the tedious rb-package, e.g. `}<a parentName="p" {...{
        "href": "https://anaconda.org/conda-forge/rb-eventmachine"
      }}>{`rb-eventmachine`}</a>{`. So why not try out the javascript based blog framework?`}</p>
    <p>{`There are quite a few framework based on Javascript, like Hexo, etc. But if you love ReactJS and Markdown, `}<a parentName="p" {...{
        "href": "https://github.com/react-static/react-static/tree/master/"
      }}>{`React Static`}</a>{` and `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/"
      }}>{`Gatsby`}</a>{` might catch your eyes. In my first trials, I dumped React Static because of too much scratch work need to be done for MDX mixed with frontmatters.`}</p>
    <h1>{`So Gatsby?`}</h1>
    <h2>{`Pros`}</h2>
    <ul>
      <li parentName="ul">{`All in JS`}</li>
      <li parentName="ul">{`A lot of good plugins`}</li>
      <li parentName="ul">{`A lot of optimization for static generation like images`}</li>
      <li parentName="ul">{`Support MDX with Frontmatters`}</li>
    </ul>
    <h2>{`Cons`}</h2>
    <ul>
      <li parentName="ul">{`ReactJS is required`}</li>
      <li parentName="ul">{`GraphQL is required`}</li>
    </ul>
    <h1>{`How to Migrate`}</h1>
    <h2>{`UI`}</h2>
    <p>{`Basically ReactJS doesn't like the dangerously old html template in Jekyll. Redesign from scratch is necessary. I redesign all the modules and try to keep my favorite elements as possible. For `}<a parentName="p" {...{
        "href": "https://threejs.org/"
      }}>{`Three.js`}</a>{` ocean wave and some tiny scripts, still work in progress. But overall, the current UI looks nice and clean. I'll add more dynamic items later.`}</p>
    <p>{`I also replaced the old background gradient color images with css gradient animation for better performance.`}</p>
    <p>{`Meanwhile, of course responsive and mobile friendly page is always my goal.`}</p>
    <h2>{`Posts`}</h2>
    <p>{`I need to support my old frontmatters as much as possible, and the old markdown posts can be directly used in MDX. Resources like images and links need to change a bit in these posts. To get images, GraphQL is used. It looks tedius and confusing at first, but later when you modularize them, it works better with benefits of image loading optimization.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token function-variable function"
          }}>{`Image`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter"
          }}>{`props`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
  `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`StaticQuery
    query`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`graphql`}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`
      query {
        images: allFile {
          edges {
            node {
              relativePath
              name
              childImageSharp {
                fluid(maxWidth: 600) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    `}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
    render`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`data`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` image `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` data`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`images`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`edges`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`find`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`n`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` n`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`relativePath`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`includes`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`props`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`filename`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
      `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// do something for your image`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
  `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`default`}</span>{` Image`}</code></pre></div>
    <p>{`Tweak these query with `}<a parentName="p" {...{
        "href": "http://localhost:8000/___graphql"
      }}>{`http://localhost:8000/___graphql`}</a></p>
    <h2>{`Images`}</h2>
    <p>{`The powerful Gatsby plugin preprocess static images and optimize them when loading out of box. For other format like gif and svg, we have to keep the original. Static webpage in Gatsby allow you to spend very little effort to achieve something very close to professional. As below, when website initially load Grey SVG image, it is blazing fast! Then lazily, higher res png image will be loaded. Making sure you won't wait for assets loading.`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/7fb9984e70f1e5026921ee844c14f91a/38af3/ninja-fluid-svg.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,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')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Ninja Gaiden Image Preprocess into Gray B&W SVG",
            "title": "Ninja Gaiden Image Preprocess into Gray B&W SVG",
            "src": "/static/7fb9984e70f1e5026921ee844c14f91a/0a47e/ninja-fluid-svg.png",
            "srcSet": ["/static/7fb9984e70f1e5026921ee844c14f91a/8a4e8/ninja-fluid-svg.png 150w", "/static/7fb9984e70f1e5026921ee844c14f91a/5a46d/ninja-fluid-svg.png 300w", "/static/7fb9984e70f1e5026921ee844c14f91a/0a47e/ninja-fluid-svg.png 600w", "/static/7fb9984e70f1e5026921ee844c14f91a/38af3/ninja-fluid-svg.png 894w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Ninja Gaiden Image Preprocess into Gray B&W SVG`}</figcaption>{`
  `}</figure>
    <h1>{`Deploy`}</h1>
    <p>{`Github failed my build everytime. I need to add .nojekyll in the root of the repository!`}</p>
    <h1>{`Future Work`}</h1>
    <p>{`Continue to finish the Three.js work and tiny scripts.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      